import {Box} from "@mui/material";
import DatenForm from "./components/EditForm";
import PageTitle from "../../global/components/PageTitle";
import {SnackbarProvider} from "notistack";

export default function EditPage() {
    return (
        <Box sx={{maxWidth: 1000}}>
            <SnackbarProvider>
                <PageTitle title="Firmendaten bearbeiten"/>
                <DatenForm/>
            </SnackbarProvider>
        </Box>
    );
}